<div class="flex h-full flex-col gap-4 overflow-auto p-4 text-black">
  <app-sidebar-header (close)="close.emit()" [title]="'automation_logs.details' | translate" />

  @if (loading) {
    <div class="flex justify-center py-6">
      <app-loader size="small" />
    </div>
  } @else if (details?.summary) {
    <section class="flex flex-col gap-3 border-b border-slate-200 pb-4">
      <div class="grid grid-cols-1 gap-2 text-sm md:grid-cols-2 [&>*]:min-w-0">
        <div>
          <div class="text-slate-500">{{ 'automation_logs.task_id' | translate }}</div>
          <div class="break-all font-medium">{{ details?.summary?.task_id }}</div>
        </div>
        <div>
          <div class="text-slate-500">{{ 'automation_logs.status' | translate }}</div>
          <div class="break-words font-medium">
            {{ formatEvent($safeNavigationMigration(details?.summary?.event)) | translate }}
          </div>
        </div>
        <div>
          <div class="text-slate-500">{{ 'created_at' | translate }}</div>
          <div class="break-words font-medium">
            {{ $safeNavigationMigration(details?.summary?.created_at) | date: 'dd/MM/yyyy HH:mm:ss' }}
          </div>
        </div>
        <div>
          <div class="text-slate-500">{{ 'updated_at' | translate }}</div>
          <div class="break-words font-medium">
            {{ $safeNavigationMigration(details?.summary?.updated_at) | date: 'dd/MM/yyyy HH:mm:ss' }}
          </div>
        </div>
        <div>
          <div class="text-slate-500">{{ 'automation_action.trigger' | translate }}</div>
          <div class="break-words font-medium">
            {{ formatTrigger($safeNavigationMigration(details?.summary?.trigger)) | translate }}
          </div>
        </div>
        <div>
          <div class="text-slate-500">{{ 'automation_action.action' | translate }}</div>
          <div class="break-words font-medium">
            {{ formatAction($safeNavigationMigration(details?.summary?.action)) | translate }}
          </div>
        </div>
        <div>
          <div class="text-slate-500">{{ 'automation_logs.chat_id' | translate }}</div>
          <button
            class="break-all text-left font-medium text-blue-600 hover:underline"
            type="button"
            (click)="openChat($safeNavigationMigration(details?.summary?.chat_id))"
          >
            {{ details?.summary?.chat_id || '-' }}
          </button>
        </div>
        <div>
          <div class="text-slate-500">{{ 'automation_logs.steps_count' | translate }}</div>
          <div class="font-medium">{{ details?.summary?.steps_count }}</div>
        </div>
      </div>
    </section>

    <section class="flex flex-col gap-3">
      @for (step of details?.steps; track step.id) {
        <div class="min-w-0 rounded border border-slate-200 p-3">
          <div class="flex min-w-0 flex-col gap-1 sm:flex-row sm:items-center sm:justify-between sm:gap-2">
            <div class="min-w-0 break-words font-medium">{{ formatEvent(step.event) | translate }}</div>
            <div class="shrink-0 text-sm text-slate-500">{{ step.created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
          </div>

          <div class="mt-2 grid grid-cols-1 gap-2 text-sm md:grid-cols-2 [&>*]:min-w-0">
            @if (step.reason) {
              <div>
                <div class="text-slate-500">{{ 'automation_logs.reason' | translate }}</div>
                <div class="break-words">{{ formatReason(step.reason) | translate }}</div>
              </div>
            }
            @if (step.planner_id) {
              <div>
                <div class="text-slate-500">{{ 'automation_logs.planner_id' | translate }}</div>
                <div class="break-all">{{ step.planner_id }}</div>
              </div>
            }
            @if (step.message_id) {
              <div>
                <div class="text-slate-500">{{ 'automation_logs.message_id' | translate }}</div>
                <div class="break-all">{{ step.message_id }}</div>
              </div>
            }
            @if (step.error_code) {
              <div>
                <div class="text-slate-500">{{ 'automation_logs.error_code' | translate }}</div>
                <div class="break-all">{{ step.error_code }}</div>
              </div>
            }
          </div>

          @if (hasDetails(step)) {
            <div class="mt-3 flex flex-col gap-2">
              @if (step.error) {
                <pre
                  class="max-w-full overflow-auto whitespace-pre-wrap break-words rounded bg-red-50 p-2 text-sm text-red-700"
                  >{{ step.error }}</pre
                >
              }
              @if (step.payload) {
                <pre class="max-h-72 max-w-full overflow-auto rounded bg-slate-50 p-2 text-xs">{{
                  step.payload | json
                }}</pre>
              }
            </div>
          }
        </div>
      }
    </section>
  } @else {
    <div class="py-4 text-center">
      {{ 'nothing_found' | translate }}
    </div>
  }
</div>
